import React from 'react';
import { Box } from '@mui/material';
import HeroBanner from '../../components/home/hero-banner';
import { useHomeState } from '../context/home-context';

export default function SectionBanner() {
  const { banners } = useHomeState();

  return (
    <Box component="section" sx={{ mb: 6 }}>
      <HeroBanner banners={banners} />
    </Box>
  );
}
